import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '貨物追跡',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
};
